module.exports = __webpack_public_path__ + "static/hero-background-b520c7baa36c2c3d76265b78d32e9942.png";